import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ErrorState {
  errorMessage: string;
  setErrorMessage: (by: string) => void;
}

// Bewusst nicht persistiert: Fehlermeldungen gelten nur fuer die laufende
// Sitzung. Frueher lagen sie in localStorage ("error-storage") und wurden
// bei jedem Reload erneut angezeigt, obwohl die Ursache laengst weg war.
export const useErrorStore = create<ErrorState>()(
  devtools((set) => ({
    errorMessage: "",
    setErrorMessage: (by) => set(() => ({ errorMessage: by })),
  }))
);
